import { Outlet } from 'react-router-dom'

import { RestrictedAccess } from 'src/components'
import { useUser } from 'src/hooks'

type RequirePermissionProps = {
  requiredPermission: string | string[]
}

/**
 *
 * @used to check if the user has a specific permission to access a route
 */

export const RequireRoutePermission = ({
  requiredPermission
}: RequirePermissionProps) => {
  const { hasPermission } = useUser()

  return hasPermission(requiredPermission) ? <Outlet /> : <RestrictedAccess />
}
